import { Avatar, Stack, Typography } from '@mui/material';
import { slashDateFormat } from 'Config';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleDateIcon } from 'Images';

interface ILastDateUse {
  lastDateUse: Date;
}

export const LastDateUse = ({ lastDateUse }: ILastDateUse) => {
  return (
    <Stack direction='row' alignItems='center' gap='7px'>
      <Avatar
        src={PurpleDateIcon}
        alt={''}
        sx={{ width: '25px', height: '25px' }}
      />
      <Typography variant={'body4'}>
        {Dictionary[DICTIONARY.CompassRights].entitlements.lastUsageDate}{' '}
        {format(new Date(lastDateUse), slashDateFormat)}
      </Typography>
    </Stack>
  );
};
